import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import HttpClient from '../../utils/HttpClient';
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
// import toast from 'react-hot-toast';
// import NonMemberModal from '../../Component/Modal/NonMemberModal';
import moment from 'moment';
import NonMemberUpgradedModal from '../../Component/Modal/NonMemberUpgradedModal';
import { useNavigate } from 'react-router-dom';

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"

const NonMemberUpgraded = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState("");
    const [UpgradeID, setUpgradeID] = useState('')
    const [AllData, setAllData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "9.4rem"
        },
        {
            name: 'Customer#',
            selector: row => row.customerNo,
        },
        {
            name: 'Person Name',
            selector: row => row.personName,
            // width: "12rem"
        },

        {
            name: 'Email',
            selector: row => row.emailId,
            // width: "9.4rem"
        },

        // {
        //     name: 'Mobile No',
        //     selector: row => row.mobileNo,
        //     width: "10.7rem"
        // },



        {
            name: 'Requested Date & Time',
            selector: row => row.createdOn,
            // width: "10.7rem"

        },
        // {
        //     name: 'Activation Status',
        //     selector: row => row.loginStatus,
        //     width: "10.7rem"

        // },

        // {
        //     name: 'Status',
        //     selector: row => row.status,
        //     width: "10.7rem"

        // },
        {
            name: 'View',

            cell: (row) => (
                <i className="fa-solid fa-eye " onClick={() => handleView(row.id)}
                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
            ),
        },
        {
            name: 'Upgrade',

            cell: (row) => (
                <div className='UpgradeDiv'>
                    {!row?.isUpgrade ? <button type="button" className="btn btn-info btn-rounded" data-mdb-ripple-init onClick={() => handleUpgrade(row.id)}>Upgrade</button> :
                        <button type="button" className="btn btn-success  btn-rounded" data-mdb-ripple-init >Upgraded</button>}

                </div>
            ),
        },

        // {
        //     name: 'View',

        //     cell: (row) => (
        //         <i className="fa-solid fa-eye " onClick={() => handleView(row.id)}
        //             style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
        //     ),
        // },
    ];

    const getCategoryWiseData = async () => {
        setIsLoading(true);
        const res = await HttpClient.requestData("view-upgradation-request-byAdmin", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = [...res?.data?.filter(item => !item.isUpgrade)
                ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)), ...res?.data?.filter(item => item.isUpgrade)?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))].map((item, i) => ({
                    id: item?.nonMemId,
                    sl: i + 1,
                    customerNo: item?.SLNo || "******",
                    personName: item?.personName,
                    emailId: item?.emailId,
                    createdOn: moment(item?.createdOn).format(format1),
                    isUpgrade: item?.isUpgrade
                }));

        } else {
            setIsLoading(false);
        }
        // Filter data based on search input


        setAllData(apiData);
    }


    //MODAL VIEW
    const handleView = async (id) => {

        setSelectedDetails(id);
        setIsModalOpen(true);
    }
    // Upgrade button click handler
    const handleUpgrade = async (id) => {
        setUpgradeID(id);
    }

    // Fetch single user data
    const fetchUserData = async (userId) => {
        try {
            const res = await HttpClient.requestData('single-user/' + userId, 'GET', {});
            if (res && res?.status) {
                navigate("/add-user-form", { state: res?.data?.[0] });
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    }

    useEffect(() => {
        if (UpgradeID) {
            fetchUserData(UpgradeID);
        }
    }, [UpgradeID]);



    useEffect(() => {
        getCategoryWiseData();
    }, [])
    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        NON MEMBERS
                    </div>



                    <form>

                        <div>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded "
                                customStyles={customStyles}
                            />
                        </div>
                    </form>
                </section>
                <NonMemberUpgradedModal
                    isOpen={isModalOpen}
                    closeModal={() => setIsModalOpen(false)}
                    details={selectedDetails}
                />
            </div>

        </div>
    )
}

export default NonMemberUpgraded